/**
 * Enums associated with adjusting the scale domain for an axis
 * @readonly
 * @enum {object}
 * @property {object} xAxis - Categories which would necessitate an augmentation to the X-axis domain
 */
const domainAdjustmentCategories = Object.freeze({
	xAxis: {
		BAR_MARKER: 'barMarker',
		EVENT: 'event',
		LINEWITHSHAPES: 'lineWithShapes',
		SHAPE: 'shape'
	}
});

/**
 * Enums associated with the renderDuplicateLabels param
 * @readonly
 * @enum {object}
 * @property {string} KEEP_ALL - Render all labels (skip the check for duplicates)
 * @property {string} KEEP_LEFT - Render the left-most duplicate label
 * @property {string} KEEP_RIGHT - Render the right-most duplicate label
 */
const renderDuplicateLabelsCategories = Object.freeze({
	KEEP_ALL: 'KEEP_ALL',
	KEEP_LEFT: 'KEEP_LEFT',
	KEEP_RIGHT: 'KEEP_RIGHT'
});

/**
 * Enums associated with the showMarketCloseLabels params
 * @readonly
 * @enum {string}
 * @property {string} ALL - For left aligned labels (the default), the market close labels will be drawn to the right of the market open labels. For center and right aligned labels, the market close label will only be drawn for the current day.
 * @property {string} NONE - No market close labels will be drawn
 * @property {string} ONCE - The label will only be drawn at the last drawable location on the XAxis
 */
const showMarketCloseLabelsCategories = Object.freeze({
	ALL: 'all',
	NONE: null,
	ONCE: 'once'
});

export {
	domainAdjustmentCategories,
	renderDuplicateLabelsCategories,
	showMarketCloseLabelsCategories
};

/**
 * Enums associated with the Modcharts class
 * @readonly
 * @enum {object}
 */
export default {
	domainAdjustmentCategories,
	renderDuplicateLabelsCategories,
	showMarketCloseLabelsCategories
};
